// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContactForm.css */
:root {
  --primary-color: #144040;
  --primary-light: #1e6e64;
  --primary-dark: #0f3030;
  --secondary-color: #DCCA98;
  --secondary-light: #e5d8b7;
  --secondary-dark: #b8a87d;
  --text-light: #fff;
  --text-dark: #333333;
  --error-color: #e63946;
  --success-color: #2a9d8f;
}

.contact-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--primary-light), var(--primary-color));
  padding: 20px;
  font-family: 'Arial, sans-serif';
}

.contact-form {
  width: 100%;
  max-width: 700px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(220, 202, 152, 0.2);
  animation: fadeIn 0.6s ease-in-out;
  position: relative;
  overflow: hidden;
}

.contact-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, var(--secondary-color), var(--primary-light));
}

.contact-form h2 {
  text-align: center;
  color: var(--secondary-color);
  font-size: 2.25rem;
  margin-bottom: 2rem;
  position: relative;
}

.contact-form h2::after {
  content: "";
  display: block;
  width: 100px;
  height: 2px;
  background-color: var(--secondary-color);
  margin: 0.8rem auto 0;
  opacity: 0.7;
}

.contact-flex-container {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.contact-flex-item {
  flex: 1 1;
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-group label {
  display: flex;
  align-items: center;
  margin-bottom: 0.6rem;
  color: var(--secondary-color);
  font-weight: 500;
}

.input-icon {
  margin-right: 10px;
  color: var(--secondary-color);
  font-size: 1.1rem;
}

.input-group input,
.input-group textarea {
  width: 100%;
  padding: 0.9rem;
  border-radius: 8px;
  border: 1px solid rgba(220, 202, 152, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text-light);
  font-size: 1rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.input-group input:focus,
.input-group textarea:focus {
  outline: none;
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 2px rgba(220, 202, 152, 0.2);
}

/* Placeholder styling */
.input-group input::placeholder,
.input-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}

/* For Firefox */
.input-group input::-moz-placeholder,
.input-group textarea::-moz-placeholder {
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}

/* For Edge */
.input-group input::-ms-input-placeholder,
.input-group textarea::-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.6);
}

/* For Chrome, Safari, and Opera */
.input-group input::-webkit-input-placeholder,
.input-group textarea::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.textarea-group {
  width: 100%;
  margin-bottom: 2rem;
}

.textarea-group textarea {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 120px;
  box-sizing: border-box;
  resize: vertical;
  line-height: 1.5;
}

.contact-form button {
  background-color: var(--secondary-color);
  color: var(--primary-dark);
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.1rem;
  width: 100%;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.contact-form button:hover:not(:disabled) {
  background-color: var(--secondary-light);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.contact-form button:disabled {
  background-color: rgba(220, 202, 152, 0.5);
  cursor: not-allowed;
}

.error-message {
  color: var(--error-color);
  background-color: rgba(230, 57, 70, 0.1);
  padding: 0.8rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
  text-align: center;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive styles */
@media (max-width: 768px) {
  .contact-flex-container {
    flex-direction: column;
    gap: 0;
  }
  
  .contact-form {
    padding: 2rem;
  }
  
  .contact-form h2 {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .contact-form {
    padding: 1.5rem;
  }
  
  .input-group input,
  .input-group textarea {
    padding: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pricing/ContactForm.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,+EAA+E;EAC/E,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,wBAAwB;EACxB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA,wBAAwB;AACxB;;EAEE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,gBAAgB;AAChB;;EAEE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,aAAa;AACb;;EAEE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* ContactForm.css */\n:root {\n  --primary-color: #144040;\n  --primary-light: #1e6e64;\n  --primary-dark: #0f3030;\n  --secondary-color: #DCCA98;\n  --secondary-light: #e5d8b7;\n  --secondary-dark: #b8a87d;\n  --text-light: #fff;\n  --text-dark: #333333;\n  --error-color: #e63946;\n  --success-color: #2a9d8f;\n}\n\n.contact-form-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--primary-light), var(--primary-color));\n  padding: 20px;\n  font-family: 'Arial, sans-serif';\n}\n\n.contact-form {\n  width: 100%;\n  max-width: 700px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(220, 202, 152, 0.2);\n  animation: fadeIn 0.6s ease-in-out;\n  position: relative;\n  overflow: hidden;\n}\n\n.contact-form::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  background: linear-gradient(90deg, var(--secondary-color), var(--primary-light));\n}\n\n.contact-form h2 {\n  text-align: center;\n  color: var(--secondary-color);\n  font-size: 2.25rem;\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.contact-form h2::after {\n  content: \"\";\n  display: block;\n  width: 100px;\n  height: 2px;\n  background-color: var(--secondary-color);\n  margin: 0.8rem auto 0;\n  opacity: 0.7;\n}\n\n.contact-flex-container {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.contact-flex-item {\n  flex: 1;\n}\n\n.input-group {\n  margin-bottom: 1.5rem;\n}\n\n.input-group label {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.6rem;\n  color: var(--secondary-color);\n  font-weight: 500;\n}\n\n.input-icon {\n  margin-right: 10px;\n  color: var(--secondary-color);\n  font-size: 1.1rem;\n}\n\n.input-group input,\n.input-group textarea {\n  width: 100%;\n  padding: 0.9rem;\n  border-radius: 8px;\n  border: 1px solid rgba(220, 202, 152, 0.3);\n  background-color: rgba(255, 255, 255, 0.1);\n  color: var(--text-light);\n  font-size: 1rem;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.input-group input:focus,\n.input-group textarea:focus {\n  outline: none;\n  border-color: var(--secondary-color);\n  box-shadow: 0 0 0 2px rgba(220, 202, 152, 0.2);\n}\n\n/* Placeholder styling */\n.input-group input::placeholder,\n.input-group textarea::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n  opacity: 1;\n}\n\n/* For Firefox */\n.input-group input::-moz-placeholder,\n.input-group textarea::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n  opacity: 1;\n}\n\n/* For Edge */\n.input-group input::-ms-input-placeholder,\n.input-group textarea::-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* For Chrome, Safari, and Opera */\n.input-group input::-webkit-input-placeholder,\n.input-group textarea::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.textarea-group {\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.textarea-group textarea {\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 120px;\n  box-sizing: border-box;\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.contact-form button {\n  background-color: var(--secondary-color);\n  color: var(--primary-dark);\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 1.1rem;\n  width: 100%;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.contact-form button:hover:not(:disabled) {\n  background-color: var(--secondary-light);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.contact-form button:disabled {\n  background-color: rgba(220, 202, 152, 0.5);\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: var(--error-color);\n  background-color: rgba(230, 57, 70, 0.1);\n  padding: 0.8rem;\n  border-radius: 6px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .contact-flex-container {\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .contact-form {\n    padding: 2rem;\n  }\n  \n  .contact-form h2 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .contact-form {\n    padding: 1.5rem;\n  }\n  \n  .input-group input,\n  .input-group textarea {\n    padding: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
